import React from 'react';
import { Tooltip, Icon } from 'antd';
import utils from '../../../utils';
import fetch from '../../fetch';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection = () => {
    return DataGrid.selections;
}

const headers = utils.columns([
    { type: 'selection' },
    {
        key: '$index',
        label: '序号',
        width: 80
    },
    {
        key: 'schoolTypeName',
        label: '学校类型',
        width: 100,
    },
    {
        key: 'cityName',
        label: '学生所属教育局',
        width: 130
    },
    {
        key: 'schoolName',
        label: '学校',
        width: 180,
        render: (data) => {
            return <Tooltip title={data}>{data}</Tooltip>
        }
    },
    {
        key: 'total',
        label: '评价次数',
        width: 130
    },
    {
        key: 'termName',
        label: '学期',
        width: 140
    }, {
        key: '', label: '浏览下载', width: 50, render: (d, row) => {
            return <div> <a className='survey-statistics-report-a-2'
                href={`${fetch.base}survey/report/printtable2byscorenew/${row.schoolId}/80`}
                schoolid={row.schoolId} style={{ display: 'inline-block' }}
                target="_blank" onClick={() => {
                }}>
                <Icon type="eye"></Icon>
                预览表2</a>
            </div>
        },
        width: 300
    },
])

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] !== '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('survey/report/queryreport?' + params.join('&'), keywords)
        .then((response) => {
            if (response.code === 200) {
                setTimeout(() => {
                    const element = document.getElementById("survey-statistics-report-input-number")
                    let baseUrl = `${fetch.base}survey/report/printtable2byscorenew`
                    const score = element.value ? element.value : 80
                    const arrys = document.getElementsByClassName("survey-statistics-report-a-2")
                    for (let i = 0; i < arrys.length; i++) {
                        const schoolId = arrys[i].getAttribute("schoolid")
                        arrys[i].href = `${baseUrl}/${schoolId}/${score}`
                    }
                }, 200);
                return response.payload.data;
            }
        }).then(data => (
            Object.assign({
                result: data.dataList || [],
                selects: (data.dataList || []).map(d => ({
                    value: d.schoolId,
                    checked: false,
                })),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: (data.dataList || []).length ? '' : '暂无数据...'
            }))
        )

}

export default {
    setRefresh,
    onSelect,
    getSelection,
    headers,
    querySearch
}